// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoSelect from "../../../components/Inputs/GoSelect";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import CoaTreeView from "./CoaTreeView";
// Services
import { get } from "../../../services/FetchHelper";
import ConfigService from "./Config.service";
import SpinService from "../../../services/SpinService";
// Utils
import Config from "./Config";
// Hooks
import usePermissions from "../../../hooks/usePermissions";

const initialFilter = { sort: "id", order: "asc", max: 10, offset: 0, search: "" };

const ChartOfAccounts = () => {
    const permission = usePermissions();
    const spinService = SpinService();
    const [filter, setFilter] = useState(initialFilter);
    const [modules, setModules] = useState([]);
    const [config, setConfig] = useState(Config[0]);
    const [open, setOpen] = useState(false);
    const [master, setMaster] = useState({
        entries: [],
        total_count: 0
    });
    const [masterId, setMasterId] = useState(undefined);
    const getMasters = async () => {
        if (config.componentName !== "Tree View") {
            spinService.on();
            const response = await get(config.entityApi, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}`);
            const data = await response.json();
            setMaster(data);
            spinService.off();
        }
    };

    const onView = (row) => {
        setMasterId(row.id);
        setOpen(true);
    };

    const handleChange = (event) => {
        setFilter(initialFilter);
        setConfig(event.target.value);
    };

    const onClose = () => {
        setMasterId(undefined);
        getMasters();
        setOpen(false);
    };

    useEffect(() => {
        if (config.componentName !== "initial") {
            getMasters();
        }
    }, [filter, config]);

    useEffect(() => {
        let filterdMenus = Config.filter((item) => permission.has(item.viewPermission));
        setModules(filterdMenus);
        setConfig(filterdMenus[0])
    }, []);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h6"
                        component="div"
                        sx={{ flexGrow: 1 }}>
                        Chart Of Accounts {config.componentName !== "initial" && `- ${config.componentName}`}
                    </Typography>
                    <GoSelect
                        title="Select Master"
                        name="master"
                        value={config}
                        items={modules}
                        displayKey="componentName"
                        itemValue="fullItem"
                        handleChange={(e) => handleChange(e)}
                        size="small"
                    />
                    {permission.has(config.addPermission) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={() => setOpen(true)}
                        >
                            New
                        </Button>}
                </Stack>
                {
                    config.componentName !== "Tree View" && <Card>
                        <GoTable
                            tableHeads={config.tableHeader}
                            tableDatas={master.entries}
                            totalCount={master.total_count}
                            filter={filter}
                            onFilter={(filter) => setFilter(filter)}
                            onView={(row) => onView(row)} />
                    </Card>
                }
                {
                    config.componentName === "Tree View" && <Card>
                        <CoaTreeView />
                    </Card>
                }
            </Container>
            {
                config.componentName !== "initial" && open && <GoDrawer
                    title={config.title}
                    open={open}
                    onClose={() => onClose()}
                >
                    <ConfigService name={config.title} onClose={() => onClose()} id={masterId} />
                </GoDrawer>
            }
        </React.Fragment>
    );
};

export default ChartOfAccounts;